import actions from '../../actionTypes';

export default (url) => {
  return {
    type: actions.RESET_LOGIN
  };
};


// WEBPACK FOOTER //
// ./src/reducers/auth/actions/resetLogin.js